module.exports = __webpack_public_path__ + "img/3.424b2f99.jpg";